// "12 min", "1 h 05 min"
export function minutes(seconds) {
  const m = Math.round((seconds || 0) / 60);
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${String(m % 60).padStart(2, '0')} min`;
}

// "12 min · 8.4 km"
export function drive(leg) {
  if (!leg) return '';
  return `${minutes(leg.seconds)} · ${(leg.metres / 1000).toFixed(1)} km`;
}

// Directions in the phone's map app (Google Maps opens the app on Android).
export function directionsUrl(job) {
  const dest = job.coord ? `${job.coord[1]},${job.coord[0]}` : encodeURIComponent([job.addressLine1, job.town, job.postcode].filter(Boolean).join(', '));
  return `https://www.google.com/maps/dir/?api=1&destination=${dest}&travelmode=driving`;
}
